import { createFileRoute } from "@tanstack/react-router";
import { CityPage } from "@/components/CityPage";
import { CITIES, buildCityLdJson } from "@/lib/cities";
import { IMAGES } from "@/lib/images";

const data = CITIES.lund;
const URL = "https://bbnnordic.se/solfilm-lund";

export const Route = createFileRoute("/solfilm-lund")({
  head: () => ({
    meta: [
      { title: `Solfilm Lund — auktoriserad 3M-installatör | BBN Nordic` },
      { name: "description", content: `Solfilm i Lund: 3M-auktoriserad installation, 10 års garanti, snabb offert. ${data.reach}.` },
      { property: "og:title", content: "Solfilm Lund — auktoriserad 3M-installatör | BBN Nordic" },
      { property: "og:description", content: `Auktoriserad 3M-installatör i Lund sedan 2008. Sänker värme, bländning och UV i villa, kontor och butik — 10 års produktgaranti, fast pris efter mätning. ${data.reach}.` },
      { property: "og:url", content: URL },
      { property: "og:image", content: data.image ?? IMAGES.solfilmHero },
      { property: "og:type", content: "website" },
    ],
    links: [{ rel: "canonical", href: URL }],
    scripts: [
      {
        type: "application/ld+json",
        children: JSON.stringify(buildCityLdJson(data)),
      },
    ],
  }),
  component: () => <CityPage data={data} campaignLanding />,
});
